export default __webpack_public_path__ + "static/media/workouttimes_6@2x.3029169b.jpg";